import { render } from "./Form-Tabungan.vue?vue&type=template&id=6838ac70"
import script from "./Form-Tabungan.vue?vue&type=script&lang=js"
export * from "./Form-Tabungan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__